import "core-js/modules/es.array.push.js";
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-a8b50e5a"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "stop-trade-container"
};
const _hoisted_2 = {
  class: "content-item"
};
const _hoisted_3 = {
  class: "fb"
};
const _hoisted_4 = {
  class: "trade-option"
};
const _hoisted_5 = {
  class: "trade-item"
};
const _hoisted_6 = {
  class: "trade-item"
};
const _hoisted_7 = {
  class: "content-item",
  style: {
    "padding": "2px 0 2px 0"
  }
};
const _hoisted_8 = {
  class: "entrust-view"
};
const _hoisted_9 = {
  class: "table-header"
};
import { ref, onMounted, watch, onBeforeUnmount, createVNode } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import store from '@/store';
import { useI18n } from 'vue-i18n';
import { Modal, message } from 'ant-design-vue';
import TradeArea from '@/components/TradeArea.vue';
import TabBar from '@/components/TabBar.vue';
import TradeForm from '@/components/TradeForm.vue';
import SpotTable from '@/components/SpotTable.vue';
import { getUserAsset, exchangeTrade, orderList } from '@/apis';
import { soptFmt } from '@/util/orderFmt';
export default {
  __name: 'SpotTrade',
  setup(__props) {
    const route = useRoute();
    const router = useRouter();
    const {
      t
    } = useI18n();
    const tradeType = ref(0);
    const klineKey = ref("");
    const buyForm = ref();
    const sellForm = ref();
    const assetList = ref([]);
    const assetUsdt = ref(0);
    const typeAsset = ref(0);
    const currentPage = ref(1);
    const currentTotal = ref(0);
    const currentLoading = ref(false);
    const currentList = ref([]);
    const historyPage = ref(1);
    const historyTotal = ref(0);
    const historyLoading = ref(false);
    const historyList = ref([]);
    const tabActive = ref(0);
    const showForm = ref(0);
    const klineChange = watch(klineKey, async () => {
      const findItem = assetList.value.find(item => {
        return item.name === store.state.marketInfo[klineKey.value].stock;
      });
      if (findItem) typeAsset.value = Math.floor(findItem.total * 10000) / 10000;
    });
    onMounted(async () => {
      if (route.query.key && route.query.key !== '') {
        klineKey.value = route.query.key;
        if (route.query.key == 'ERSUSDT') router.push('/ieo/ERS');
      } else {
        if (store.state.marketCoin.length > 0) {
          klineKey.value = store.state.marketCoin[0];
        } else {
          const keyWatch = watch(() => store.state.marketCoin.length, () => {
            klineKey.value = store.state.marketCoin[0];
            keyWatch();
          });
        }
      }
      init();
    });
    const init = async () => {
      if (store.state.token !== '') {
        const res = await getUserAsset({
          platform: 0
        });
        if (res.code === 200 && res.data) {
          assetList.value = res.data.map(item => {
            if (item.marketName === 'USDT') {
              assetUsdt.value = item.active ? Number(item.active).toFixed(4) : 0;
            }
            if (item.marketName === 'BTC') {
              //向下取整
              typeAsset.value = item.active ? Math.floor(item.active * 10000) / 10000 : 0;
            }
            return {
              name: item.marketName,
              // icon: process.env.VUE_APP_IMG + item.icon,
              total: item.active ? item.active : 0,
              active: item.active ? Number(item.active).toFixed(4) : 0
            };
          });
          const findItem = assetList.value.find(item => {
            return item.name === store.state.marketInfo[klineKey.value].stock;
          });
          if (findItem) typeAsset.value = Math.floor(findItem.total * 10000) / 10000;
        }
        orderInit();
      }
    };
    const keyChnage = key => {
      if (key === 'ERSUSDT') {
        router.push(`/ieo/ERS`);
        return;
      }
      klineKey.value = key;
      buyForm.value.clear();
      sellForm.value.clear();
    };
    const orderInit = async (page = null) => {
      let data = {};
      let type = '';
      if (tabActive.value === 0) {
        // 当前委托
        currentLoading.value = true;
        if (page) currentPage.value = page;
        data = {
          page: currentPage.value,
          size: 10
        };
        type = 'wait';
      } else {
        historyLoading.value = true;
        if (page) historyPage.value = page;
        data = {
          page: historyPage.value,
          size: 10
        };
        type = 'finish';
      }
      const res = await orderList(type, data);
      let list = [];
      if (res.code === 200 && res.data && res.data.list) {
        list = soptFmt(res.data.list);
        if (tabActive.value === 0) {
          currentList.value = list;
          currentTotal.value = res.data.total;
          currentLoading.value = false;
        } else {
          historyList.value = list;
          historyTotal.value = res.data.total;
          historyLoading.value = false;
        }
      } else {
        currentLoading.value = false;
        historyLoading.value = false;
      }
    };
    const tabChange = index => {
      if (currentLoading.value || historyLoading.value) {
        return;
      }
      tabActive.value = index;
      orderInit();
    };
    const commit = form => {
      if (store.state.token === '') {
        router.push({
          name: 'login'
        });
        return;
      }
      if (tradeType.value === 1) {
        if (form.price === '' && Number(form.price) <= 0) {
          message.error(t('priceTip'));
          return;
        }
      }
      if (form.number === '' || Number(form.number) <= 0) {
        message.error(t('numberTip'));
        return;
      }
      if (form.side === '0') {
        if (Number(form.total) > form.max) {
          message.error(t('withdrawNumLess'));
          return;
        }
      } else {
        if (Number(form.number) > form.max) {
          message.error(t('withdrawNumLess'));
          return;
        }
      }
      Modal.confirm({
        title: t('tip'),
        content: createVNode('div', {
          style: ''
        }, t('tradeConfirm')),
        okText: t('confirmText'),
        okType: 'danger',
        cancelText: t('cancelText'),
        centered: true,
        onOk: async () => {
          const data = {
            marketId: store.state.marketInfo[klineKey.value].id,
            tradeNum: form.number === '' ? 0 : Number(form.number),
            side: Number(form.side),
            tradeAmount: Number(form.total)
          };
          if (tradeType.value === 0) {
            data['trade_type'] = 'market';
          } else {
            data['trade_type'] = 'limit';
            data['price'] = Number(form.price);
          }
          return await new Promise((resolve, reject) => {
            exchangeTrade(data['trade_type'], data).then(res => {
              if (res.code !== 200) {
                reject();
                message.error(res.msg !== '' ? res.msg : t('tradeError'));
                return;
              }
              message.success(t('tradeSuccess'));
              buyForm.value.clear();
              sellForm.value.clear();
              resolve();
              init();
            });
          });
        }
      });
    };
    onBeforeUnmount(() => {
      klineChange();
    });
    return (_ctx, _cache) => {
      const _component_van_button = _resolveComponent("van-button");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(TradeArea, {
        "kline-key": klineKey.value,
        height: "1130px",
        onChange: keyChnage,
        "key-list": _unref(store).state.marketCoin
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createVNode(_component_van_button, {
          color: showForm.value ? '#F7F6FB' : '#2eb266',
          block: "",
          onClick: _cache[0] || (_cache[0] = $event => showForm.value = 0),
          style: _normalizeStyle({
            '--van-button-border-radius': '2px',
            color: showForm.value ? '#919497' : 'white',
            width: '50%',
            clipPath: 'polygon(0 0, 100% 0, 95% 100%, 0 100%)',
            fontWeight: 700,
            fontSize: '16px',
            '--van-button-default-height': '38px'
          })
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)('toBuy')), 1)]),
          _: 1
        }, 8, ["color", "style"]), _createVNode(_component_van_button, {
          color: showForm.value ? '#D04C64' : '#F7F6FB',
          block: "",
          onClick: _cache[1] || (_cache[1] = $event => showForm.value = 1),
          style: _normalizeStyle({
            '--van-button-border-radius': '2px',
            color: showForm.value ? 'white' : '#919497',
            width: '50%',
            clipPath: 'polygon(5% 0, 100% 0, 100% 100%, 0 100%)',
            fontWeight: 700,
            fontSize: '16px',
            '--van-button-default-height': '38px'
          })
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)('toSell')), 1)]),
          _: 1
        }, 8, ["color", "style"])]), _createVNode(TabBar, {
          "tab-list": [_unref(t)('marketPrice'), _unref(t)('limitPrice')],
          "tab-active": tradeType.value,
          onChange: _cache[2] || (_cache[2] = index => tradeType.value = index),
          style: {
            "padding": "20px 20px"
          }
        }, null, 8, ["tab-list", "tab-active"]), _createElementVNode("div", _hoisted_4, [_withDirectives(_createElementVNode("div", _hoisted_5, [_createVNode(TradeForm, {
          ref_key: "buyForm",
          ref: buyForm,
          "use-num": `${assetUsdt.value}`,
          "use-stock": "USDT",
          stock: _unref(store).state.marketInfo[klineKey.value]?.stock,
          bg: "#03ad73",
          text: _unref(t)('buy'),
          "trade-type": tradeType.value,
          kline: klineKey.value,
          onCommit: commit,
          side: "0"
        }, null, 8, ["use-num", "stock", "text", "trade-type", "kline"])], 512), [[_vShow, showForm.value == 0]]), _withDirectives(_createElementVNode("div", _hoisted_6, [_createVNode(TradeForm, {
          ref_key: "sellForm",
          ref: sellForm,
          "use-num": `${typeAsset.value}`,
          "use-stock": _unref(store).state.marketInfo[klineKey.value]?.stock,
          "trade-type": tradeType.value,
          stock: _unref(store).state.marketInfo[klineKey.value]?.stock,
          bg: "#d1514b",
          text: _unref(t)('sell'),
          kline: klineKey.value,
          side: "1",
          onCommit: commit
        }, null, 8, ["use-num", "use-stock", "trade-type", "stock", "text", "kline"])], 512), [[_vShow, showForm.value == 1]])])]),
        _: 1
      }, 8, ["kline-key", "key-list"])]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createVNode(TabBar, {
        "tab-list": [_unref(t)('entrust'), _unref(t)('historyOrder')],
        "active-bg": "white",
        "tab-active": tabActive.value,
        onChange: tabChange
      }, null, 8, ["tab-list", "tab-active"]), _createElementVNode("div", {
        class: "right-btn",
        onClick: _cache[3] || (_cache[3] = $event => _unref(router).push({
          name: 'spotCurrent'
        }))
      }, _toDisplayString(_unref(t)('allOrder')), 1)]), _withDirectives(_createVNode(SpotTable, {
        data: currentList.value,
        "list-cnt": currentTotal.value,
        loading: currentLoading.value,
        current: true,
        onInit: init,
        onNext: orderInit,
        page: currentPage.value
      }, null, 8, ["data", "list-cnt", "loading", "page"]), [[_vShow, tabActive.value === 0]]), _withDirectives(_createVNode(SpotTable, {
        data: historyList.value,
        "list-cnt": historyTotal.value,
        loading: historyLoading.value,
        onInit: init,
        onNext: orderInit,
        page: historyPage.value
      }, null, 8, ["data", "list-cnt", "loading", "page"]), [[_vShow, tabActive.value === 1]])])])]);
    };
  }
};